module.exports = __webpack_public_path__ + "img/3-2.c5d866bb.svg";